import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
import { CreateTripModalActions } from './create.trip.modal.provider';

@Component({
    templateUrl: './create.trip.modal.component.html',
    styleUrls: ['./create.trip.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CreateTripModalComponent extends BaseComponent {

    public hubName: string;
    public tripFormGroup: FormGroup;
    public newTripTitle: string;
    public newTripLabel = 'Type here such as "Day 1 - Family Vacation"';
    @ViewChild('sendHelpSuccess') public sendHelpSuccess: SuccessWrapComponent;

    constructor(private dialogRef: MatDialogRef<CreateTripModalComponent>,
                private activatedRoute: ActivatedRoute,
                private actions: CreateTripModalActions,
                private formBuilder: FormBuilder,
                private visitorApiService: VisitorApiService,) {
        super({activatedRoute});

        this.tripFormGroup = this.formBuilder.group({
            'tripTitle': [null, [Validators.required]],
        });
        if (this.isMobile) {
            this.newTripLabel = 'Type here such as "Day 1"';
        }
    }

    public createTrip($event) {
        if (!this.newTripTitle) {
            return;
        }

        this.actions.confirm(this.newTripTitle, $event);
        this.dialogRef.close();
    }

    public close() {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/create.trip.modal/create.trip.modal.component.ts